module.exports = __webpack_public_path__ + "img/india.fff391e4.png";